import React from 'react';
import { PersistGate } from 'redux-persist/es/integration/react';
import { ConfigProvider } from 'react-avatar';

import { BrowserRouter } from 'react-router-dom';

import { Provider } from 'react-redux';
import './config/ReactotronConfig';
// precisa vir dps do reactotron se não as configurações não vem p/ o store
import { store, persistor } from './store';

import ThemeProvider from 'ThemeProvider';

import ADXRoutes from './routes';

import cacheAvatar from './config/cacheAvatar';

import ToastContainer from 'components/ToastContainer';
import Dialog from 'components/Dialog';

import GlobalStyle from './styles/global';
import AppProvider from './hooks';

function App() {
  return (
    <ConfigProvider cache={cacheAvatar}>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <BrowserRouter>
            <ThemeProvider>
              <AppProvider>
                <ADXRoutes />
              </AppProvider>
              <GlobalStyle />
              <ToastContainer autoClose={3000} />
              <Dialog />
            </ThemeProvider>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </ConfigProvider>
  );
}

export default App;
